
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  *
  * The source file is located at:
  *   /codebuild/output/src2723206075/src/vl-app/pages/survey.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from '@hooks/useRouter';
import SurveyViewer from '@components/SurveyViewer/SurveyViewer';

function Survey() {
  const { t } = useTranslation('common');
  const { query } = useRouter();
  const { survey_id, save_to } = query;

  const surveyId = Array.isArray(survey_id) ? survey_id[0] : survey_id;
  const saveTo = Array.isArray(save_to) ? save_to[0] : save_to;

  if (!surveyId) {
    return <div>{t('Survey ID is required')}</div>;
  }

  return <SurveyViewer survey_id={surveyId} save_to={saveTo} />;
}


export const Route = createFileRoute('/survey')({ component: Survey });
